module.exports = __webpack_public_path__ + "img/263-2.4bd2e32a.jpg";